export default (formatter: () => boolean, hash: boolean) => {
  const path = formatter ? formatter() : (hash ? window.location.hash : window.location.pathname)
  return { path, title: document.title }
}
